import { CommonModule } from '@angular/common';
import { AfterContentInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

import { ToggleItemDirective } from './toggle-item.directive';

@Component({
    selector: 'bg-toggle',
    templateUrl: './toggle.component.html',
    imports: [CommonModule],
})
export class ToggleComponent implements OnChanges, AfterContentInit {
    @Input() value: string;
    @Output() itemSelected = new EventEmitter<string>();
    items: ToggleItemDirective[] = [];

    selectedItem(item: ToggleItemDirective, isNotifyItemSelected: boolean = true) {
        const itemsToDisable = this.items.filter((tempItem) => {
            return tempItem !== item;
        });

        itemsToDisable.forEach((item) => {
            item.disableActive();
        });

        item.selectItem();

        if (isNotifyItemSelected) {
            this.itemSelected.emit(item.value);
        }
    }

    addItem(item: ToggleItemDirective) {
        this.items.push(item);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes.value.previousValue !== changes.value.currentValue && !!changes.value.currentValue) {
            const itemToSelect = this.findSelectedItem(changes.value.currentValue);

            if (itemToSelect) {
                this.selectedItem(itemToSelect, false);
            }
        }
    }

    ngAfterContentInit() {
        setTimeout(() => {
            const itemToSelect = this.findSelectedItem(this.value);
            this.selectedItem(itemToSelect, false);
        }, 0);
    }

    findSelectedItem(valueOfItemToSelect: string) {
        const itemToSelect = this.items.filter((tempItem) => {
            return tempItem.value === valueOfItemToSelect;
        })[0];

        return itemToSelect;
    }
}
